class LightBox {

    private box: HTMLElement;
    private slides = [] as HTMLElement[];
    private gallery = [] as HTMLElement[];
    private currentSlide: number;
    private images: any[];

    constructor() {
        const entities = ([...document.querySelectorAll('a.lightbox')] as HTMLLinkElement[]);
        this.images = entities.map((entity, i) => {

            entity.addEventListener('click', e => {
                e.preventDefault();
                this.create();
                this.setSlide(i);
            });
            return {
                alt: entity.title,
                src: entity.href,
                thumb: entity.querySelector('img')?.src
            };
        });
    }

    private create() {
        this.currentSlide = -1;
        this.box = document.createElement('div');
        this.box.id = 'lightbox';

        this.createButtons().forEach((button) => this.box.appendChild(button));
        this.box.appendChild(this.createSlider());
        this.box.appendChild(this.createGallery());
        document.querySelector('footer')?.appendChild(this.box);
        setTimeout(() => {
            this.box.style.opacity = '1';
            this.toggleScroll();
        }, 50);

    }

    private remove() {
        this.slides = [];
        this.gallery = [];
        this.currentSlide = 0;
        this.box.style.opacity = '0';
        setTimeout(() => {
            this.box.remove();
        }, 500);
        this.toggleScroll();
    }

    private changeSlide(direction: number) {
        const nextSlide = this.currentSlide + direction;
        if (nextSlide < 0) {
            this.setSlide(this.slides.length - 1);
        } else if (nextSlide >= this.slides.length) {
            this.setSlide(0);
        } else {
            this.setSlide(nextSlide);
        }
    }
    
    public nextSlide() {
        this.changeSlide(1);
    }
    
    public previousSlide() {
        this.changeSlide(-1);
    }

    private setSlide(index: number) {
        if (this.currentSlide === index) {
            return;
        }
        this.slides[index].style.transition = '';
        if (this.currentSlide > -1) {
            this.slides[this.currentSlide].classList.remove('current');
            this.gallery[this.currentSlide].classList.remove('current');
        }
    
        this.slides.forEach((slide, i) => {
            slide.style.left = i < index ? '-100%' : i > index ? '100%' : '0';
        });
    
        this.slides[index].classList.add('current');
        this.gallery[index].classList.add('current');
        const image = this.slides[index].querySelector('img');
        if (image) {
            image.style.transform = '';
        }
        this.currentSlide = index;
    }

    private createButton(className: string, innerHTML: string, clickHandler: () => void) {
        const button = document.createElement('div');
        button.classList.add(className);
        button.innerHTML = innerHTML;
        button.addEventListener('click', clickHandler);
        return button;
    }

    private createButtons() {
        const close = this.createButton('close', '<svg viewBox="0 0 10 10" width="25" height="25" fill="none"><use xlink:href="#cross"></use></svg>', () => this.remove());
        const prev = this.createButton('prev', '<svg viewBox="0 0 10 6" width="20" height="12" fill="none" style="transform: rotate(90deg);"><use xlink:href="#arrow"></use></svg>', () => this.previousSlide());
        const next = this.createButton('next', '<svg viewBox="0 0 10 6" width="20" height="12" fill="none" style="transform: rotate(-90deg);"><use xlink:href="#arrow"></use></svg>', () => this.nextSlide());
        return [close, prev, next];
    }

    private createSlider() {
        const slider = document.createElement('div');
        slider.classList.add('slider');

        this.images.forEach(({src, alt}) => {
            const slide = document.createElement('div');
            slide.classList.add('slide');
            
            const image = document.createElement('img') as HTMLImageElement;
            image.src = src;
            image.alt = alt;
    
            this.initTouchEventHandlers(image);
    
            const title = document.createElement('div');
            title.innerText = alt;
    
            slide.appendChild(image);
            slide.appendChild(title);
    
            this.slides.push(slide);
            slider.appendChild(slide);
        });

        return slider;
    }

    private createGallery() {
        const gallery = document.createElement('div');
        gallery.classList.add('gallery');

        this.images.forEach(({alt, thumb}, i) => {
            const image = document.createElement('img') as HTMLImageElement;
            image.src = thumb;
            image.alt = alt;

            image.addEventListener('click', () => {
                this.setSlide(i);
            });

            gallery.appendChild(image);
            this.gallery.push(image);
        });

        return gallery;
    }

    private initTouchEventHandlers(image: HTMLImageElement)
    {
        let x = 0;
        let y = 0;
        let direction = '';
        image.addEventListener("touchstart", e => { 
            direction = '';
            x = e.changedTouches[0].pageX;
            y = e.changedTouches[0].pageY;
        });
        image.addEventListener("touchend", e => {
            if(direction == 'vertical') {
                this.remove();
            }
            if(direction == 'horizontal') {
                if(e.changedTouches[0].pageX - x > 0) {
                    this.previousSlide();
                } else {
                    this.nextSlide();
                }
            }
        });
        image.addEventListener("touchmove", e => {
            if(direction == '') {
                if(Math.abs(x - e.changedTouches[0].pageX) > 20) {
                    direction = 'horizontal';
                } else if(Math.abs(y - e.changedTouches[0].pageY) > 50) {
                    direction = 'vertical';
                }
            }

            if(direction == 'horizontal') {
                image.style.transform = 'translateX('+ (e.changedTouches[0].pageX - x) +'px)';
            } else if(direction == 'vertical') {
                image.style.transform = 'translateY('+ (e.changedTouches[0].pageY - y) +'px)';
            }
        });
    }

    private toggleScroll()
    {
        const html = document.querySelector('html');
        if(html) {
            html.style.overflow = html.style.overflow == 'hidden' ? '' : 'hidden';
            html.style.height = html.style.height == '100%' ? '' : '100%';
        } 
    }
}
document.addEventListener("DOMContentLoaded", () => {
    const lightbox = new LightBox();
    (window as any).lightbox = lightbox;
});